import Vue from 'vue'
import store from "@/store"

var GoalCommitmentSelectPromptContent = Vue.extend({
  template: `
  <div>
    <el-select
      :disabled="disabled"
      class="d-block w-100 mb-1"
      v-model="targetGoalId"
      placeholder="Select a goal">
      <el-option
        v-for="goal in goal_list"
        :key="goal.$key"
        :label="goal.name || goal.cachedName"
        :value="goal.$id" />
    </el-select>

    <br />

    <el-select
      :disabled="disabled"
      class="d-block w-100 mb-1"
      v-model="targetCommitmentId"
      placeholder="Select a commitment">
      <el-option
        v-for="(commitment, commitmentId) in commitment_list"
        :key="commitment.$key"
        :label="commitment.name"
        :value="commitmentId" />
    </el-select>

    <!-- <pre>
targetGoalId:       {{targetGoalId}}
targetCommitmentId: {{targetCommitmentId}}
targetMemberId:     {{targetMemberId}}
    </pre> -->
  </div>
  `,
  props: {
    goal_list: {},
    preselectedGoalId: {},
    preselectedCommitmentId: {},
  },
  data: () => ({
    targetGoalId: null,
    targetCommitmentId: null,
    targetMemberId: null,
    disabled: false,
  }),
  beforeCreate() {
    this.$store = store;
  },
  mounted() {
    if ( this.preselectedGoalId ) {
      this.targetGoalId = this.preselectedGoalId;
    }
    if ( this.preselectedCommitmentId ) {
      this.targetCommitmentId = this.preselectedCommitmentId;
    }
  },
  watch: {
    preselectedGoalId(id) { this.targetGoalId = id },
    preselectedCommitmentId(id) { this.targetCommitmentId = id },
    targetCommitmentId( id ) {
      this.targetMemberId = id && Object.keys(this.commitment_list).length > 0
        ? this.commitment_list[ id ].assignedUserId
        : null
    }
  },
  computed: {
    commitment_list() {
      if ( this.targetGoalId ) {
        return this.$models
          .commitmentMeta
          .with({ goalId: this.targetGoalId })
          .getList() // fetch list once / should always be loaded
          .items
      }
      return {}
    }
  },
  methods: {
    reset() {
      // this.targetGoalId = null
      // this.targetCommitmentId = null
      // this.targetMemberId = null
      this.disableOk = false
    },
    disable() {
      this.disabled = true
    },
    enable() {
      this.disabled = false
    }
  }
})

// TODO: inconsisstent goals names
// TODO: Disable ok button when waiting for done()

export default {
  methods: {
    $goal_commitment_prompt({
      title,
      filterGoalId = null,
      filterCommitmentId = null,
      preselectedGoalId = null,
      preselectedCommitmentId = null
    } = {}) {

      // goal_list_meta_without_deleted ?
      // TODO: Disable instead of filter

      let goal_list = this.$models.goalMeta.getters.all_goals_without_deleted;
      goal_list = goal_list.filter( goal => goal.$id !== filterGoalId );

      /* let goal_list = this.$models.userGoalSettings.getList().itemsAsArray() */

      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: title || 'Select a goal and commitment',
          message: this.$createElement(GoalCommitmentSelectPromptContent, {
            props: { goal_list, preselectedGoalId, preselectedCommitmentId }
          }),
          showCancelButton: true,
          beforeClose: (action, instance, done) => {

            let dataContainer = instance.$children.find( child => 'targetGoalId' in child )
            dataContainer.disable()

            let done_with_reset = () => {
              done();
              dataContainer.enable();
              dataContainer.reset();
            }

            if ( action !== 'confirm'
              || !dataContainer.targetGoalId
              || !dataContainer.targetCommitmentId ) {
              done_with_reset();
              return
            }

            resolve({
              done: done_with_reset,
              ...dataContainer._data
            })

            // TODO: What happens if operation after this fails and done is not called?
          }
        }).catch(e => e);
      });
    }
  }
}
